import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import AdunitGroup from "@/features/adunitGroup/adunitGroupView.vue";
import AdunitGroupEdit from "@/features/adunitGroup/adunitGroupEditView.vue";
import AnalyticsReport from "@/features/analytics/analyticsReportView.vue";
import AnalyticsReportEdit from "@/features/analytics/analyticsReportEditView.vue";
import Home from "@/features/home/homeView.vue";
import HelpCenter from "@/features/helpCenter/helpCenterView.vue";
import Login from "@/features/login/loginView.vue";
import Setting from "@/features/setting/settingView.vue";
import NotFound from "@/features/notFound/notFoundView.vue";
import UnAuthorized from "@/features/unAuthorized/unAuthorizedView.vue";
import { AxiosResponse } from "axios";
import { CheckSessionResponse } from "@/commons/types";
import CoreWebVitals from "@/features/coreWebVitals/coreWebVitalsView.vue";
import CwvDomains from "@/features/coreWebVitals/cwvDomainsView.vue";
import ReleaseNote from "@/features/releaseNote/releaseNoteView.vue";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: "/dashboard",
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: {
        hasNavigation: false,
        requiredAuth: false,
      },
    },
    {
      path: "/dashboard",
      name: "Home",
      component: Home,
      meta: {
        hasNavigation: true,
        requiredAuth: true,
      },
    },
    {
      path: "/analytics",
      name: "Analytics",
      component: AnalyticsReport,
      meta: {
        hasNavigation: true,
        requiredAuth: true,
      },
    },
    {
      path: "/analytics/setting",
      name: "NewReport",
      component: AnalyticsReportEdit,
      meta: {
        hasNavigation: true,
        requiredAuth: true,
      },
    },
    {
      path: "/analytics/setting/:reportId",
      name: "EditReport",
      component: AnalyticsReportEdit,
      meta: {
        hasNavigation: true,
        requiredAuth: true,
      },
    },
    {
      path: "/adunit/group",
      name: "AdunitGroup",
      component: AdunitGroup,
      meta: {
        hasNavigation: true,
        requiredAuth: true,
      },
    },
    {
      path: "/adunit/group/setting",
      name: "AdunitGroupSetting",
      component: AdunitGroupEdit,
      meta: {
        hasNavigation: true,
        requiredAuth: true,
      },
    },
    {
      path: "/adunit/group/setting/:adunitGroupId",
      name: "AdunitGroupEdit",
      component: AdunitGroupEdit,
      meta: {
        hasNavigation: true,
        requiredAuth: true,
      },
    },
    {
      path: "/wrapper",
      name: "Wrapper",
      component: NotFound,
    },
    {
      path: "/flux-engagement",
      name: "Engagement",
      component: NotFound,
    },
    {
      path: "/flux-layout",
      name: "Layout",
      component: NotFound,
    },
    {
      path: "/flux-id-manager",
      name: "IdManager",
      component: NotFound,
    },
    {
      path: "/core-web-vitals",
      name: "CoreWebVitals",
      component: CoreWebVitals,
      meta: {
        hasNavigation: true,
        requiredAuth: true,
      },
    },
    {
      path: "/core-web-vitals/domains",
      name: "CwvDomains",
      component: CwvDomains,
      meta: {
        hasNavigation: true,
        requiredAuth: true,
      },
    },
    {
      path: "/release-note",
      name: "ReleaseNote",
      component: ReleaseNote,
      meta: {
        hasNavigation: true,
        requiredAuth: true,
      },
    },
    {
      path: "/help",
      name: "Help",
      component: HelpCenter,
      meta: {
        hasNavigation: true,
        requiredAuth: true,
      },
    },
    {
      path: "/setting",
      name: "Setting",
      component: Setting,
      meta: {
        hasNavigation: true,
        requiredAuth: true,
      },
    },
    {
      path: "/404",
      name: "NotFound",
      component: NotFound,
      meta: {
        hasNavigation: false,
        requiredAuth: false,
      },
    },
    {
      path: "/403",
      name: "UnAuthorized",
      component: UnAuthorized,
      meta: {
        hasNavigation: false,
        requiredAuth: false,
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (
    to.matched.some(record => record.path === "/login") &&
    to.matched.some(record => !record.meta.requiredAuth)
  ) {
    next();
  } else {
    store
      .dispatch("auth/checkAuth")
      .then((res: AxiosResponse<CheckSessionResponse>) => {
        store.commit("auth/setLoginUser", res.data.user);
        next();
      })
      .catch(() => {
        if (from.path === "/") {
          next({ path: "/login" });
        } else {
          next({ path: "/login" + to.name ? "?redirect=" + to.name : "" });
          location.reload();
        }
      });
  }
});

export default router;
